import { REDIRECT_ROUTE_PATH, ROUTE_PATH } from './consts';

export const createStorePageUrl = storeId =>
  `${ROUTE_PATH.replace(':storeId', storeId)}`;

export const createRedirectStorePageUrl = storeId =>
  `${REDIRECT_ROUTE_PATH.replace(':storeId', storeId)}`;
